import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import CrmRestrictionsHeader from './containers/CrmRestrictionsHeader/CrmRestrictionsHeader';
import CrmRestrictionsList from './screens/CrmRestrictionsList/CrmRestrictionsList';
import { crmRestrictionsStore } from './store';

const CrmRestrictionsScreen: FC = observer((props) => {
  useEffect(() => {
    crmRestrictionsStore.getCrmRestrictions();
  }, []);

  return (
    <>
      <CrmRestrictionsHeader />
      <CrmRestrictionsList />
    </>
  );
});

export default CrmRestrictionsScreen;
